export default
`
After progressing through the four stages of grief, families and individuals start accepting that they or their family member have the condition.\r\n
  
In this piece, the page is blank except a black dot. The dot represents that the condition is permanent and will always be present in the individual’s life. The blank space, that it is no longer so overwhelming. The individual has moved towards a place of peace.\r\n

`


// WEBPACK FOOTER //
// ./src/content/acceptance.js